import { debounce } from 'lodash';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { Component } from 'react';
import { Nav, NavItem } from 'reactstrap';

import NavigationEntity from '../../../types/NavigationEntity';
import HeaderNavAction from '../../header/HeaderNavAction';
import HeaderNavLink from '../../header/HeaderNavLink';
import HeaderNavMenu from '../../header/HeaderNavMenu';
import NavigationEntityItem from '../../navigation/NavigationEntityItem';
import NavigationMenuRowDropdownItem from '../NavigationMenuRowDropdownItem';

@observer
class NavigationMenuRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeMenuId: null,
    };
  }

  setActiveMenuId = (id) => {
    this.setState({
      activeMenuId: id,
    });
  };

  debouncedHoverMenu = debounce((callback) => {
    if (callback) {
      callback();
    }
  }, 200);

  getAccessibilityAttributes = (item) => {
    if (!item.accessible_text) {
      return {};
    }

    const accessibilityId = item.accessible_text
      .replace(/\s/g, '-')
      .toLowerCase();

    return {
      id: accessibilityId,
      'aria-labelledby': accessibilityId,
    };
  };

  render() {
    const { isNoFollowLink, surface } = this.props;
    return (
      <Nav navbar className="NavigationMenuRow">
        {this.props.items.map((item) =>
          item.children && item.children.length > 0 ? (
            <HeaderNavMenu
              surface={surface}
              debouncer={this.debouncedHoverMenu}
              isOpen={this.state.activeMenuId === item.id}
              setActiveId={this.setActiveMenuId}
              entity={item}
              label={item.label}
              key={item.id}
              ariaLabel={item.accessible_text}
            >
              {item.children.map((subItem) => (
                <NavigationMenuRowDropdownItem
                  item={subItem}
                  isNoFollowLink={isNoFollowLink}
                  key={subItem.id}
                />
              ))}
            </HeaderNavMenu>
          ) : (
            <NavItem key={item.id}>
              {item.path ? (
                <HeaderNavLink
                  surface={surface}
                  to={item.path}
                  type={item.type}
                  active={item.active}
                  isNoFollowLink={isNoFollowLink}
                  {...this.getAccessibilityAttributes(item)}
                >
                  <div
                    className={classNames(
                      'NavigationEntityLink',
                      'NavigationEntityLink__title',
                      {
                        'NavigationEntityLink__has-image': item.image,
                      }
                    )}
                  >
                    {item.image && (
                      <img src={item.image} alt={item.image} loading="lazy" />
                    )}
                    {item.label}
                  </div>
                </HeaderNavLink>
              ) : item.onClick ? (
                <HeaderNavAction
                  surface={surface}
                  onClick={item.onClick}
                  active={item.active}
                >
                  {item.label}
                </HeaderNavAction>
              ) : (
                <NavigationEntityItem
                  entity={item}
                  isNoFollowLink={isNoFollowLink}
                />
              )}
            </NavItem>
          )
        )}
      </Nav>
    );
  }
}

NavigationMenuRow.propTypes = {
  items: PropTypes.arrayOf(NavigationEntity).isRequired,
  isNoFollowLink: PropTypes.bool,
  surface: PropTypes.oneOf(['top', 'bottom']),
};

NavigationMenuRow.defaultProps = {
  surface: 'top',
};

export default NavigationMenuRow;
